export default "__VITE_ASSET__228bf755__"